export default "__VITE_ASSET__82b9a0fc__"